
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function SubraceIndex() {
  return (
    <FSIndex
      data_type="subrace"
      quick_fields={["race"]}
    />
  );
}
